import "./DetallePopup.scss";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Button } from "react-bootstrap";
import { BotonRegresar } from "../../../components/boton-regresar/BotonRegresar";
import { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import ReactQuill, { Quill } from "react-quill";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import * as yup from "yup";
import ImageEdit from "quill-image-edit-module";
import { stringToDate } from "../../../Utilidades/commons";
import { StatusAlertService } from "react-status-alert";
import { PopupRequest } from "../../../interfaces/popupInterfaces";
import { getPopup, guardarPopup } from "../../../Services/PopupsService";
import { postAdjunto } from "../../../Services/AdjuntosService";

var Size = Quill.import("attributors/style/size") as any;
Size.whitelist = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "25px",
  "30px",
  "40px",
  "50px",
];
Quill.register(Size, true);
Quill.register("modules/imageEdit", ImageEdit);

let quill: any = null;

export const DetallePopup = () => {
  const [popupId, setPopupId] = useState(0);
  const [descripcion, setDescripcion] = useState("");
  const [titulo, setTitulo] = useState("");
  const [fechaPublicacion, setFechaPublicacion] = useState<Date>(new Date());
  const [fechaCierre, setFechaCierre] = useState<Date>(new Date());
  const params = useParams();
  let idComunicado = params.comunicadoId;

  const bannerSchema = yup.object({
    titulo: yup.string(),
    descripcion: yup.string(),
    fechaPublicacion: yup.date().required("Fecha publicacion es requerida"),
    fechaCierre: yup.date().required("Fecha cierre es requerida"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(bannerSchema),
    defaultValues: {
      titulo: "",
      descripcion: "",
      fechaPublicacion: new Date(),
      fechaCierre: new Date(),
    },
  });

  const imagenContenidoHandler = async () => {
    const input = document.createElement("input");

    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();
    input.onchange = async () => {
      var file: any = input && input.files ? input.files[0] : null;
      var formData = new FormData();
      formData.append("file", file);
      const quillRef: any = quillEl?.current;
      if (quillRef) {
        quill = quillRef?.getEditor();
        const response: any = await postAdjunto(formData).catch(
          ({ response }) => {
            const { data } = response;
            StatusAlertService.showError(data.meta.message);
            return false;
          }
        );
        if (response.data) {
          const range = quill.getSelection();
          let downloadUri: string = response.data.fileDownloadUri.replace("null", "/api/v1/front-institucional");
          quill.insertEmbed(
            range.index,
            "image",
            downloadUri
          );
        }
      }
    };
  };

  const colors = [
    "#000000",
    "#e60000",
    "#ff9900",
    "#ffff00",
    "#008a00",
    "#0066cc",
    "#9933ff",
    "#ffffff",
    "#facccc",
    "#ffebcc",
    "#ffffcc",
    "#cce8cc",
    "#cce0f5",
    "#ebd6ff",
    "#bbbbbb",
    "#f06666",
    "#ffc266",
    "#ffff66",
    "#66b966",
    "#66a3e0",
    "#c285ff",
    "#888888",
    "#a10000",
    "#b26b00",
    "#b2b200",
    "#006100",
    "#0047b2",
    "#6b24b2",
    "#444444",
    "#5c0000",
    "#663d00",
    "#666600",
    "#003700",
    "#002966",
    "#3d1466",
  ];

  const modul = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          //[{ font: Font.whitelist }],
          [{ font: [] }],
          [
            "bold",
            "italic",
            "underline",
            "strike",
            "blockquote",
            "link",
            "code-block",
            "image",
            { align: [] },
          ],
          [{ size: Size.whitelist }],
          [{ color: colors }, { background: colors }],
          [{ list: "ordered" }, { list: "bullet" }],
        ],
        handlers: {
          image: imagenContenidoHandler,
        },
      },
      imageEdit: {
        modules: ["Resize", "DisplaySize", "Toolbar", "Delete"],
      },
      clipboard: {
        matchVisual: false,
      },
    }),
    []
  );

  const navigate = useNavigate();

  const quillEl = useRef(null);

  useEffect(() => {
    const quillRef: any = quillEl?.current;
    if (quillRef) {
      quill = quillRef?.getEditor();
    }

    if (idComunicado !== "0") {
      setPopupId(Number(idComunicado));

      getPopup(Number(idComunicado)).then((response) => {
        if (response.data && response.data.data) {
          console.log("respuestaaa", response.data.data);

          setDescripcion(response.data.data.contenido);
          setTitulo(response.data.data.titulo);
          setFechaPublicacion(response.data.data.inicio);
          setFechaCierre(response.data.data.fin);
          setTitulo(response.data.data.titulo);
          setValue("descripcion", response.data.data.contenido);
        }
      });
    }
  }, []);

  const guardar = async () => {

    if (titulo === '') {
      StatusAlertService.showError('Se requiere campo Titulo');
      return;
    }
    if (descripcion === '') {
      StatusAlertService.showError('Se requiere campo Descrición');
      return;
    }

    let popup = {} as PopupRequest;
    popup.id = popupId;
    popup.titulo = titulo;
    popup.contenido = descripcion;
    popup.inicio = moment(fechaPublicacion).format("YYYY-MM-DD");
    popup.fin = moment(fechaCierre).format("YYYY-MM-DD");
    popup.estatus = "1";

    guardarPopup(popup)
      .then((result) => {
        reset();
        StatusAlertService.showSuccess("Exito");
        navigate("/popups");
      })
      .catch((error) => console.error(error));
  };

  const onSubmit = (data) => {
    console.log("Form Submitted:", data);
    guardar();
  };

  const onChangeContenido = (target: any) => {
    const src = target.slice(target.indexOf('src="data:')).split('"')[1];
    if (src) {
      fetch(src)
        .then((res) => res.blob())
        .then((blob) => {
          const formData = new FormData();
          const file = new File([blob], "imagen.jpeg");
          formData.append("file", file);
          guardarAdjuntoCopiado(formData, src, target);
        });
    }
    setDescripcion(target);
  };

  const guardarAdjuntoCopiado = async (
    formData: FormData,
    imagedata: string,
    conte: string
  ) => {
    const response: any = await postAdjunto(formData).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data) {
      let downloadUri: string = response.data.fileDownloadUri.replace("null", "/api/v1/front-institucional");
      setDescripcion(conte.replace(imagedata, downloadUri));
    }
  };

  return (
    <>
      <Row className="pt-3 mb-2">
        <BotonRegresar></BotonRegresar>
      </Row>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row className="mt-3 agregar-usuario">
          <Col>
            <Row className="titulo">
              <Col className="heading-1">
                {popupId === 0 ? "Nuevo Popup" : "Editar Popup"}
              </Col>
            </Row>

            <Row className="mt-3">
            <Col sm={12} className="minimocolumna">
                <Form.Label>Titulo</Form.Label>
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder=""
                    aria-label="Search"
                    value={titulo}
                    maxLength={200}
                    onChange={(e) => setTitulo(e.target.value)}
                    className={errors.titulo ? " borde-rojo" : ""}
                  />
                </Form>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
              <Form.Label>Descripción</Form.Label>
                <ReactQuill
                  ref={quillEl}
                  theme="snow"
                  placeholder="Escribe contenido popup..."
                  className="editor-class"
                  modules={modul}
                  value={descripcion}
                  onChange={(e) => onChangeContenido(e)}
                  //onChange={setContenido}
                />
                <p className="text-danger">{errors.descripcion?.message}</p>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col sm={5} className="minimocolumna">
                <Form.Label>Fecha de publicación</Form.Label>
                <Form.Control
                  {...register("fechaPublicacion")}
                  type="date"
                  name="datepicd"
                  placeholder="Desde"
                  min={moment(new Date().toString()).format("YYYY-MM-DD")}
                  value={moment(fechaPublicacion.toString()).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={(e) =>
                    setFechaPublicacion(stringToDate(e.target.value))
                  }
                  className={errors.fechaPublicacion ? " borde-rojo" : ""}
                />
                <p className="text-danger">
                  {errors.fechaPublicacion?.message}
                </p>
              </Col>
              <Col sm={2}></Col>
              <Col sm={5} className="minimocolumna">
                <Form.Label>Fecha de cierre</Form.Label>
                <Form.Control
                  {...register("fechaCierre")}
                  type="date"
                  name="datepicd"
                  placeholder="Desde"
                  className={errors.fechaCierre ? " borde-rojo" : ""}
                  min={moment(new Date().toString()).format("YYYY-MM-DD")}
                  value={moment(fechaCierre.toString()).format("YYYY-MM-DD")}
                  onChange={(e) => setFechaCierre(stringToDate(e.target.value))}
                />
              </Col>
            </Row>

            <div className="d-flex flex-row-reverse bd-highlight mt-3">
              <Button type="submit" variant="primary" className="float-end">
                {popupId === 0 ? "Crear Popup" : "Actualizar Popup"}
              </Button>
              <Button
                variant="secondary"
                className="float-end me-3"
                onClick={() => navigate(-1)}
              >
                Cancelar
              </Button>
            </div>
          </Col>
        </Row>
      </form>
    </>
  );
};
